import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { ObjectUrlModal } from "./ObjectUrlModal";
import configs from "../../utils/configs";

const appName = configs.translation("app-name").toLowerCase().replace(/ /g, "-");

let loadingObject = null;

try {
  loadingObject = require(`../../assets/models/LoadingObject_${appName}.glb`);
} catch (e) {
  loadingObject = require("../../assets/models/LoadingObject_app.glb");
}

const isMobile = AFRAME.utils.device.isMobile() || AFRAME.utils.device.isMobileVR();

export function ObjectUrlModalContainer({ scene, onClose, sourceNavigate }) {
  const onSubmit = useCallback(
    ({ file, url, href, hideHref, smoothTransition = false }) => {
      scene.emit("add_media", {
        src: (file && file.length > 0 && file[0]) || url || loadingObject,
        href,
        hideHref,
        smoothTransition
      });
      onClose();
    },
    [scene, onClose]
  );

  return (
    <ObjectUrlModal
      isMobile={isMobile}
      showModelCollectionLink={configs.feature("show_model_collection_link")}
      modelCollectionUrl={configs.link("model_collection", "https://sketchfab.com/mozillareality")}
      onSubmit={onSubmit}
      onClose={onClose}
      sourceNavigate={sourceNavigate}
    />
  );
}

ObjectUrlModalContainer.propTypes = {
  scene: PropTypes.object.isRequired,
  onClose: PropTypes.func
};
